import { getLocation } from '@/common/utils/geo'
import { getCityByPoi } from './service'
import { TabNames } from '@/pages-v2/home/storeList/component/StoreTabs/constants'
// 排除的参数
export const cityIdKey = {
  [TabNames.priority.key]: 'cityId',
  [TabNames.area.key]: 'AreaCityId',
  [TabNames.my.key]: 'cityId',
  [TabNames.all.key]: 'cityId'
}

let geo = null
export async function getGeo() {
  geo = await getLocation()
  return geo
}

export async function getDefaultCityId(hasCache) {
  if (hasCache) return ''
  const geo = await getGeo()
  if (geo.hasError) {
    return ''
  } else {
    const { lat, lng } = geo
    const result = await getCityByPoi({ lat, lng })
    const { cityId = '' } = result || {}
    return cityId
  }
}
